import axios from 'axios';
import config from '../config/config';

export function addMeetingAttendee({ meeting_id, contact }) {
  //contact = {label:'Sophia H', value:'99'}
  const postData = {
    meeting_id,
    contact_id: contact.value
  };
  return axios
    .post(config.apiURL + `/meeting_attendee`, postData, {
      headers: {
        'Content-Type': 'application/json',
        token: config.getToken()
      }
    })
    .then((res) => ({
      res,
      contact
    }));
}
export function removeMeetingAttendee({ meeting_id, attendee }) {
  const postData = {
    meeting_id: {
      String: meeting_id,
      Valid: true
    },
    contact_id: attendee.value //poc_id
  };
  return axios
    .delete(config.apiURL + `/delete_meeting_attendee`, {
      headers: {
        'Content-Type': 'application/json',
        token: config.getToken()
      },
      data: postData
    })
    .then((res) => ({
      res,
      attendee
    }));
}

export async function getNotAttendedContacts({ meeting_id }) {
  //   {
  //     "poc_id": "",
  //     "contact_id": "1429",
  //     "email_address": "",
  //     "contact_name": "Tesa Wrobleski",
  //     "email_id": {
  //         "String": "",
  //         "Valid": false
  //     },
  //     "meeting_id": {
  //         "String": "377",
  //         "Valid": true
  //     }
  // }
  const res = await axios.get(
    config.apiURL + `/contacts_not_attended_meeting/meeting_id/${meeting_id}`,
    {
      headers: {
        'Content-Type': 'application/json',
        token: config.getToken()
      }
    }
  );

  return res;
}
